import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Accueil</Link> / À propos
          </div>
          <h1>À propos de l'AEII</h1>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '640px' }}>
            Africa Economic Intelligence Institute — un institut panafricain au service de la recherche,
            de l'intelligence économique et de la valorisation des connaissances stratégiques.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container mission-grid">
          <div>
            <span className="section-kicker">Qui sommes-nous</span>
            <h2 className="section-title">Un institut panafricain d'excellence</h2>
            <p style={{ color: '#667180', marginBottom: '16px' }}>
              L'AEII (Africa Economic Intelligence Institute) est un institut panafricain spécialisé
              dans l'intelligence économique, la recherche stratégique, l'analyse économique et la
              valorisation des travaux scientifiques consacrés au développement du continent.
            </p>
            <p style={{ color: '#667180', marginBottom: '16px' }}>
              Notre ambition est de constituer la référence documentaire et analytique pour les
              institutions publiques, les entreprises, les chercheurs et les organisations
              internationales engagées dans la compréhension et le pilotage des économies africaines.
            </p>
            <p style={{ color: '#667180' }}>
              À travers cette plateforme numérique, l'AEII met à disposition une base de connaissances
              structurée, actualisée en continu et accessible selon des formules d'abonnement
              adaptées à chaque profil d'utilisateur.
            </p>
          </div>
          <img src="/images/about-office.jpg" alt="Bureaux et équipe de l'AEII" loading="lazy" />
        </div>
      </section>

      <section className="section bg-alt">
        <div className="container">
          <span className="section-kicker">Notre raison d'être</span>
          <h2 className="section-title">Mission, vision &amp; valeurs</h2>
          <div className="grid grid-3" style={{ marginTop: '32px' }}>
            <div className="value-card">
              <i className="fa-solid fa-bullseye"></i>
              <h4>Mission</h4>
              <p>Produire et diffuser une intelligence économique rigoureuse pour éclairer la décision publique et privée en Afrique.</p>
            </div>
            <div className="value-card">
              <i className="fa-solid fa-eye"></i>
              <h4>Vision</h4>
              <p>Devenir la plateforme panafricaine de référence en matière de recherche économique et d'intelligence stratégique.</p>
            </div>
            <div className="value-card">
              <i className="fa-solid fa-heart"></i>
              <h4>Valeurs</h4>
              <p>Rigueur scientifique, indépendance, panafricanisme, excellence académique et engagement pour le développement durable.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <span className="section-kicker">Nos activités</span>
          <h2 className="section-title">Ce que fait l'AEII</h2>
          <div className="grid grid-4" style={{ marginTop: '32px' }}>
            <div className="pillar-item" style={{ flexDirection: 'column', textAlign: 'center' }}>
              <div className="pillar-icon" style={{ margin: '0 auto 12px' }}>
                <i className="fa-solid fa-chart-line"></i>
              </div>
              <h4>Intelligence économique</h4>
              <p>Veille stratégique et analyse concurrentielle continue.</p>
            </div>
            <div className="pillar-item" style={{ flexDirection: 'column', textAlign: 'center' }}>
              <div className="pillar-icon" style={{ margin: '0 auto 12px' }}>
                <i className="fa-solid fa-flask"></i>
              </div>
              <h4>Recherche stratégique</h4>
              <p>Production d'études prospectives sur les grands enjeux africains.</p>
            </div>
            <div className="pillar-item" style={{ flexDirection: 'column', textAlign: 'center' }}>
              <div className="pillar-icon" style={{ margin: '0 auto 12px' }}>
                <i className="fa-solid fa-scale-balanced"></i>
              </div>
              <h4>Analyse économique</h4>
              <p>Décryptage des politiques publiques et des dynamiques de marché.</p>
            </div>
            <div className="pillar-item" style={{ flexDirection: 'column', textAlign: 'center' }}>
              <div className="pillar-icon" style={{ margin: '0 auto 12px' }}>
                <i className="fa-solid fa-graduation-cap"></i>
              </div>
              <h4>Publication scientifique</h4>
              <p>Valorisation des travaux de recherche via des supports de haute qualité.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-primary">
        <div className="container">
          <span className="section-kicker" style={{ color: '#e0b04c' }}>Notre parcours</span>
          <h2 className="section-title">Une trajectoire au service du continent</h2>
          <div className="timeline" style={{ marginTop: '40px', color: '#fff' }}>
            <div className="timeline-item">
              <span className="year">2021</span>
              <h4 style={{ color: '#fff' }}>Création de l'AEII</h4>
              <p style={{ color: 'rgba(255,255,255,0.8)' }}>
                Fondation de l'institut avec une première équipe de chercheurs panafricains.
              </p>
            </div>
            <div className="timeline-item">
              <span className="year">2023</span>
              <h4 style={{ color: '#fff' }}>Élargissement du réseau de partenaires</h4>
              <p style={{ color: 'rgba(255,255,255,0.8)' }}>
                Signature de partenariats avec des universités et centres de recherche africains.
              </p>
            </div>
            <div className="timeline-item">
              <span className="year">2025</span>
              <h4 style={{ color: '#fff' }}>Structuration de la base documentaire</h4>
              <p style={{ color: 'rgba(255,255,255,0.8)' }}>
                Constitution d'une bibliothèque de plus de 500 publications thématiques.
              </p>
            </div>
            <div className="timeline-item">
              <span className="year">2026</span>
              <h4 style={{ color: '#fff' }}>Lancement de la plateforme numérique</h4>
              <p style={{ color: 'rgba(255,255,255,0.8)' }}>
                Mise en ligne de la plateforme AEII Knowledge &amp; Economic Intelligence Platform.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container text-center">
          <span className="section-kicker" style={{ justifyContent: 'center' }}>Rejoignez-nous</span>
          <h2 className="section-title">Accédez à notre base de connaissances stratégiques</h2>
          <p className="section-lead" style={{ margin: '0 auto 24px' }}>
            Créez gratuitement votre compte et choisissez la formule adaptée à vos besoins de recherche.
          </p>
          <Link to="/inscription" className="btn btn-dark">Créer mon compte gratuit</Link>
        </div>
      </section>
    </>
  );
};

export default About;